var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7598 9.44922C10.7598 9.27995 10.7272 9.1237 10.6621 8.98047C10.597 8.83724 10.4993 8.70052 10.3691 8.57031L2.76172 1.12891C2.54688 0.914062 2.27995 0.806641 1.96094 0.806641C1.7526 0.806641 1.56055 0.858724 1.38477 0.962891C1.20898 1.06055 1.06901 1.19401 0.964844 1.36328C0.867188 1.53255 0.818359 1.72461 0.818359 1.93945C0.818359 2.24544 0.935547 2.51888 1.16992 2.75977L8.02539 9.44922L1.16992 16.1387C0.935547 16.3796 0.818359 16.6562 0.818359 16.9688C0.818359 17.1771 0.867188 17.3659 0.964844 17.5352C1.06901 17.7109 1.20898 17.8477 1.38477 17.9453C1.56055 18.0495 1.7526 18.1016 1.96094 18.1016C2.27995 18.1016 2.54688 17.9909 2.76172 17.7695L10.3691 10.3281C10.4993 10.1979 10.597 10.0612 10.6621 9.91797C10.7272 9.77474 10.7598 9.61849 10.7598 9.44922Z",
    fill: "#33D085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNext);
export default __webpack_public_path__ + "static/media/ico_next.f3dcf30a5ef28dc229cbd24b8b53aba2.svg";
export { ForwardRef as ReactComponent };